var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestBoardScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d34e79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42452,
    stopColor: "#bf1128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#bd081c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#611f2f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.11751,24.93383h-26.23502c-3.91569,0-7.08999,3.1743-7.08999,7.08999v35.95232c0,3.91573,3.1743,7.09003,7.08999,7.09003h26.23502c3.91569,0,7.08999-3.1743,7.08999-7.09003v-35.95232c0-3.91569-3.1743-7.08999-7.08999-7.08999ZM49.99998,63.18325c-1.36684,0-2.67426-.21789-3.90247-.59429.53487-.89143,1.34705-2.31769,1.64419-3.46665.15847-.61412.81218-3.12992.81218-3.12992.43582.81218,1.70365,1.50552,3.03087,1.50552,3.96193,0,6.83429-3.66478,6.83429-8.20117,0-4.33829-3.5459-7.60684-8.12191-7.60684-5.68533,0-8.7162,3.82321-8.7162,7.98324,0,1.94134,1.03011,4.33829,2.6743,5.11084.23772.11888.3764.05946.43582-.17826.03963-.1783.25752-1.06974.35657-1.48572.01979-.13868,0-.23772-.09905-.3764-.55466-.65371-.99048-1.88187-.99048-3.01103,0-2.91198,2.21869-5.72496,5.96269-5.72496,3.22896,0,5.50703,2.21869,5.50703,5.3684,0,3.56569-1.80266,6.0419-4.14019,6.0419-1.30742,0-2.27807-1.0697-1.96113-2.37716.37636-1.56494,1.08953-3.26855,1.08953-4.39771,0-1.01028-.53487-1.86208-1.66403-1.86208-1.30742,0-2.37712,1.36684-2.37712,3.20913,0,1.16879.39619,1.96117.39619,1.96117,0,0-1.30746,5.52687-1.54514,6.55693-.25756,1.14895-.15851,2.73372-.03963,3.78363-4.91278-1.9215-8.37947-6.69561-8.37947-12.2819,0-7.28994,5.90327-13.19317,13.19317-13.19317s13.19317,5.90322,13.19317,13.17333c0,7.28994-5.90322,13.19317-13.19317,13.19317Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestBoardScraper);
export default __webpack_public_path__ + "static/media/pinterest-board-scraper.67e1b4c52ff62972045f829f6b3e1c02.svg";
export { ForwardRef as ReactComponent };